import { useEffect } from 'react'
import { QueryProvider } from './providers/QueryProvider'
import { ThemeProvider } from './providers/ThemeProvider'
import { RTLProvider } from './providers/RTLProvider'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { TagsProvider } from './contexts/TagsContext'
import { AppRouter } from './router'
import { setLogoutHandler } from './api/client'
import { useAuthStore } from './store/authStore'
import { initializeCache } from './utils/adventureCache'

function App() {
  const { logout } = useAuthStore()

  // Set up the logout handler for the API client
  useEffect(() => {
    setLogoutHandler(logout)
  }, [logout])

  // Initialize IndexedDB cache on app startup
  useEffect(() => {
    initializeCache().catch((error) => {
      console.warn('Failed to initialize cache:', error)
    })
  }, [])

  return (
    <ErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <RTLProvider>
            <TagsProvider>
              <AppRouter />
            </TagsProvider>
          </RTLProvider>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  )
}

export default App
